
<app-filter-results [filterBy]="filterBy" [isFilterCalendar]="true"[isFilterServices]="false" [isFilterClients]="false"[isFilterCaseManagers]="false" [isFilterInAvailable]="false"
[searchBy]="searchBy" [isSearchingAvailable]="true" (onApplyFilter)="applyFilter($event)"
(resetFilters)="onResetFilters()" [filterOpen]="filterStatusParent" (closeNavEvent)="closeEvent($event)"></app-filter-results>